import { render, staticRenderFns } from "./Financingloans.vue?vue&type=template&id=2d231580&scoped=true&"
import script from "./Financingloans.vue?vue&type=script&lang=js&"
export * from "./Financingloans.vue?vue&type=script&lang=js&"
import style0 from "./Financingloans.vue?vue&type=style&index=0&id=2d231580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d231580",
  null
  
)

export default component.exports